import { makeUrl } from "../../../utils/makeUrl";

export interface FolderQueryParams {
	/**
	 * If provided, will fetch a single folder with the given ID. Otherwise, will fetch all folders (optionally filtered by folderId).
	 */
	readonly id?: string;
	/**
	 * If provided, will fetch all folders within the given folder. Ignored if `id` is provided.
	 */
	readonly folderId?: string | null;
	/**
	 * If true, will not perform any fetch and will return an empty array or null for data. Useful for cases where the folder data is not needed, such as when only performing mutations.
	 */
	readonly disabled?: boolean;
}

export const FOLDER_URL_SEGMENT = "/users/folders";

/**
 * Generates a query key for fetching folders based on the provided parameters.
 * @param params - The parameters for the folder query.
 * @returns An array representing the query key.
 */
export const getFoldersKey = (params: FolderQueryParams) => [
	FOLDER_URL_SEGMENT,
	params,
];

/**
 * Generates a URL for fetching folders based on the provided parameters.
 * @param params - The parameters for the folder query.
 * @returns A string representing the URL.
 */
export const getFoldersUrl = (params: FolderQueryParams) => {
	const url = makeUrl(FOLDER_URL_SEGMENT);
	if (params.folderId) url.searchParams.set("folderId", params.folderId);
	else if (params.folderId === null) url.searchParams.set("folderId", "null");
	return url.pathname + url.search;
};
